import { useQuery } from '@tanstack/react-query';

import { useApiClient } from '@/providers/ApiClientProvider';
import API from '@/lib/API';

import type { BannerAnnouncementResponse } from '../types';

export const useBannerAnnouncementQuery = () => {
  const { httpWithAuth, api } = useApiClient();

  return useQuery({
    queryKey: ['banner-announcement'],
    queryFn: async () =>
      await api<BannerAnnouncementResponse>(httpWithAuth.get(API.bannerAnnouncement)),
  });
};
